import React, {useEffect, useState} from 'react';
import '../../components/Toggle/Toggle.scss';

const Toggle = ({value, handleChange})=>{
    const [isChecked, setIsChecked] = useState(value || false);
    const handleOnChange = () => {
        setIsChecked(!isChecked);
        handleChange(isChecked);
      };

      useEffect(() => {
        setIsChecked(value);
    }, [value]);
    return (
        <div>
            <label className="switch">
                <input type="checkbox" checked={isChecked}
                     onChange={handleOnChange}/>
                <span className="slider round"></span>
            </label>
        </div>
    );
};

export default Toggle;
